import { FC, useContext } from 'react';
import styled from 'styled-components';
import { ListContext } from '.';

type Props = {
  name: string;
};
const TdWithProps: FC<Props> = ({ name, ...props }) => {
  const { activeColumns } = useContext(ListContext);
  return activeColumns[name] || name === 'checkbox' || name === 'settings' ? (
    <div {...props} />
  ) : null;
};

export const Td = styled(TdWithProps)`
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  & > div {
    display: flex;
  }
`;

export const BoldTd = styled(TdWithProps)`
  font-weight: 500;
  color: var(--gray-900);
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  & > div {
    display: flex;
  }
`;
